import { createFileRoute } from "@tanstack/react-router";
import { validateBilanSearch } from "../../features/insights/bilanSearch";
import { InsightsPage } from "../../features/insights/InsightsPage";

export const Route = createFileRoute("/_app/insights")({
  validateSearch: validateBilanSearch,
  component: function Insights() {
    return <InsightsPage bilan={Route.useSearch().bilan} />;
  },
});
